var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card_data"},[_c('div',{staticClass:"title_wrapper"},[_c('h5',{staticClass:"card_data_title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"card_data_items"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }